import { useEffect, useRef } from 'react';

import { getPack } from '@contagio/engine';

import { Mark } from '../art';
import { useLang, useT } from '../i18n';
import { REWARDS, nextPack, useProgress } from '../profile';

/**
 * El bono de entrar, contado en cuanto se abre el juego. Es lo unico que se
 * gana sin jugar, asi que se anuncia como un premio y no como una linea mas:
 * con la marca grande, chispas y el paquete que queda mas cerca.
 */
export function DailyBonus({ gain, onClose }: { gain: number; onClose: () => void }) {
  const t = useT();
  const lang = useLang();
  const progress = useProgress();
  const next = nextPack(progress);
  const closeRef = useRef<HTMLButtonElement>(null);

  // Lo que queda por delante: o el paquete que ya se puede pagar, o cuanto le
  // falta, o que no queda ninguno.
  const goal = !next
    ? t.bonus.all
    : next.price <= progress.points
      ? t.bonus.ready(getPack(next.id, lang).name)
      : t.bonus.next(getPack(next.id, lang).name, next.price - progress.points);

  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="modal" role="dialog" aria-modal="true" aria-label={t.bonus.label} onClick={onClose}>
      <div className="modal__panel modal__panel--ask bonus" onClick={(e) => e.stopPropagation()}>
        <p className="bonus__art" aria-hidden>
          <span className="bonus__spark bonus__spark--a" />
          <span className="bonus__spark bonus__spark--b" />
          <span className="bonus__spark bonus__spark--c" />
          <Mark className="bonus__mark" />
        </p>
        <p className="bonus__eyebrow mono">{t.bonus.eyebrow}</p>
        <p className="bonus__gain mono">{t.bonus.gain(gain)}</p>
        <h2 className="bonus__title">{t.bonus.title}</h2>
        <p className="bonus__text">
          {t.bonus.total(progress.points)} {goal}
        </p>
        <p className="bonus__text bonus__text--soft">{t.bonus.tomorrow(REWARDS.daily)}</p>
        <button ref={closeRef} type="button" className="btn btn--primary btn--block" onClick={onClose}>
          {t.bonus.close}
        </button>
      </div>
    </div>
  );
}
